import Tone from 'tone';
import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {A_RATE, K_RATE} from 'constants/automation-rates.js';

export default superclass => class extends superclass  {
    setupPitchBend() {
        this.pitchBendSignal = new Tone.Signal(0);
        this.pitchBendParameter = new AudioParamValueParameter(
            'pitchBend',
            this.pitchBendSignal,
            {
                min: -200,
                max: 200,
                defaultValue: 0,
                automationRate: A_RATE,
            });
        this.registerParameter(this.pitchBendParameter);

        this.connectPitchBend();
    }

    onPitchBend(value) {
        this.pitchBendParameter.set(value * 200, false, true);
    }

    connectPitchBend() {
        this.pitchBendSignal.disconnect();
        this.detuneSignals.forEach(
            detune => this.pitchBendSignal.connect(detune));
    }
}
